import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import { dropdownSwitch } from "./lib/search.js";
import { initUtilities } from "./lib/utilities.js";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();

	dropdownSwitch();
	initUtilities();

	waitForElem(".site-header").then((elem) => {
		matchHeaderPlaceholder();
	});

	fixHiddenMetaBox("#custom_css_settings .hide-if-js");

	singleTemplateCustomizations();
});

const waitForElem = (selector) => {
	return new Promise((resolve) => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver((mutations) => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
};
const matchHeaderPlaceholder = () => {
	const header = document.querySelector(".site-header");
	const headerPlaceholder = document.querySelector(".placeholder-header");

	function updateHeight(size) {
		headerPlaceholder.dataset.windowSize = size;
		document.querySelector(".placeholder-header").style.height = header.offsetHeight + "px";
	}

	function checkBasedOnWindowSize() {
		if (window.innerWidth >= 992 && header.dataset.windowSize !== "large") {
			updateHeight("large");
		} else if (window.innerWidth < 992 && header.dataset.windowSize !== "small") {
			updateHeight("small");
		}
	}

	checkBasedOnWindowSize();

	window.addEventListener("resize", function () {
		checkBasedOnWindowSize();
	});
};

const fixHiddenMetaBox = (selector) => {
	const fieldElem = document.querySelector(selector);

	if (fieldElem) {
		fieldElem.style.display = "block";
	}
};

const singleTemplateCustomizations = () => {
	if (!document.querySelector(".single-tribe_events")) {
		return;
	}

	const eventUrlLabel = document.querySelector(".tribe-events-event-url-label");
	if (eventUrlLabel) {
		eventUrlLabel.innerHTML = "Registration:";
	}
};
